import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../AppContextProvider";
import NodesModal from "../modals/NodesModal";
import ExplorerComponent from "../components/graph/ExplorerComponent";
import { MDBAccordion, MDBAccordionItem } from "mdb-react-ui-kit";

function FilePage() {
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [isVisibility, setIsVisibility] = useState(true);
  const [isVisibility2, setIsVisibility2] = useState(false);

  const basicRef = useRef(null);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    setTimeout(() => {
      setIsVisibility(false);
    }, 2500);

    setTimeout(() => {
      setIsVisibility2(true);
    }, 3500);
    return () => {
      setIsVisibility2(false);
    };
  }, []);

  return <ExplorerComponent />;
}
export default FilePage;
